import React from 'react'
import PropTypes from 'prop-types'
import { NoFoundTitle, NoFoundTitleDetail, NoFoundWrapper } from './styles'
import { BqButton } from '@beeq/react'
import { Text } from '../../../constants/TextConstants'

export const NoDataFound = ({ resetAdvancedSearchFilterData }) => (
  <NoFoundWrapper>
    <NoFoundTitle>{Text.NoResultsFounded}</NoFoundTitle>
    <NoFoundTitleDetail>
      {Text.NoResultsDetail}
      </NoFoundTitleDetail>
    <NoFoundTitleDetail>{Text.NoResultsDetail1}</NoFoundTitleDetail>
    <BqButton
      data-testid='advanced-search-filter-apply-button'
      border='s'
      size='medium'
      type='button'
      class='hydrated'
      onBqClick={resetAdvancedSearchFilterData}
      >
      {Text.AdvancedSearchCancelButton}
    </BqButton>
  </NoFoundWrapper>
)

NoDataFound.propTypes = {
  resetAdvancedSearchFilterData: PropTypes.func
}
